import './index.less'
import { observer } from 'mobx-react'
import useStore from '@/hooks/useStore'

import SearchPart from '@/components/Content/SearchPart'
import RuralBusiness from '@/components/Content/RuralBusiness'
import MapPart from '@/components/Content/MapPart'
import FacilityLease from '@/components/Content/FacilityLease'
import FacilityInfo from '@/components/Content/FacilityInfo'
import FacilityAmbientAnalysis from '@/components/Content/FacilityAmbientAnalysis'

function Content(props: any) {
  const uiStore = useStore('uiStore')
  const facilityStore = useStore('facilityStore')

  return (
        <div className={'NongDi-Content'}>
            <div className={'Content'} style={{ height: uiStore.uiHeight }}>
                <div className={'Content_Left'} style={{ width: uiStore.SearchPartShow ? uiStore.Content_Left_Width : 0 }}>
                    {
                        uiStore.isClickRural
                          ? <RuralBusiness />
                          : <SearchPart/>
                    }
                </div>
                <div className={'Content_Right'} style={{ width: uiStore.SearchPartShow ? uiStore.Coutent_Right_Width : '100%' }}>
                    <MapPart mapLoadedCallback={props.mapLoadedCallback} />
                </div>
                <div className={'Content_Model'} style={{ left: uiStore.SearchPartShow ? 499 : 0 }}>
                <div className={'Model_Part Facility_Lease'} >
                        {facilityStore.FacilityLeaseShow ? <FacilityLease/> : null}
                    </div>
                    <div className={'Model_Part Facility_info'}>
                        {facilityStore.FacilityInfoShow ? <FacilityInfo/> : null}
                        {facilityStore.isOpendTabsPage ? <FacilityAmbientAnalysis/> : null}
                    </div>
                </div>
            </div>
        </div>
  )
}

export default observer(Content)
